module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-bodymatter element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-002"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-002-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-002-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("K")]), _vm._v("onrad waited patiently")]), _vm._v(" for Matthew Hawley’s reply to his first question.  When it came he sensed the pain and anger in the words, although the man sitting in front of him appeared, on the surface, to be focussed and in control of his body "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("language")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘My legal representatives didn’t fabricate an unbelievable story, as you suggest, Mr Neale. What I told them was the truth, most of which was deemed inadmissible. How the evidence was perceived and twisted by the prosecution made the truth appear to be a "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("lie")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘But you must be aware, Matthew, that what the public heard during your trial was that you had a fantastic life with a beautiful, kind-hearted woman, who worshipped and doted on you. She even accepted your son to live with you both. You were a phenomenally well-off family, and willing to share that wealth you raised thousands of pounds for charity. When you have a life of stable privilege it simply doesn’t make sense that you would murder your wife.’ Konrad left a three-second pause before asking his question. ‘What can you say to help us understand why you snapped and killed her? Did you "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("snap")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He couldn’t read Matthew. He could usually pitch his questions in a particular way by watching for signs of discomfort in his interviewee, but Matthew Hawley was giving nothing away. The man was distant: cut off but not "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("aloof")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I didn’t snap, Mr Neale, that much is "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("obvious")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I see your point. Of course, it can’t have been impulsive or an act of self-defence. You took your time to mutilate Helena and, from what we have seen from the evidence, there appears to have been a reason behind how you laid out her body. Tell us then, if you would, how you came to the decision to kill your wife.  Try to build a picture that will serve to detail the events leading to your actions, two years ago, when you deliberately killed and mutilated "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Helena")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Mr Neale, I believe that is what we agreed. I’m happy to recount my story because this is for my son. I want, above anything else, for him to hear and know the truth that the court failed to examine. But please don’t expect me to tell you, in gory detail, every incision I "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("made")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Your son, Josh, was how old when you left your first "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("marriage")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Let’s straighten out the facts, Mr Neale. I did not leave. Amy had an affair and I went through the painful process of a divorce, being obliged to leave the home I had worked so hard to build for my family. Instead of a contented life, I had my heart broken.  I vowed to do whatever I had to in order to keep alive the relationship with my son who was only twelve. Unlike my ex-wife and her exaggerated claims of irreconcilable differences, I remained adult and compliant with Amy’s wishes in order to keep the peace. Somehow, I even learnt to tolerate “Pete the wanker”. No apology for referring to him in that way, the bloke is a twat, and I still hate him for decimating my family. If you have to cut that bit then so be it, but he’s still a "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("wanker")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Konrad was supposed to be listening hard to pick up a cue for his next question. He didn’t worry about the fruity language as it made for a gritty edge to the documentary and revealed a small glimmer of emotion breaking through from Matthew Hawley’s well-guarded inner feelings. Instead of concentrating on the words being spoken, he had found himself wondering which idiot researcher had got the facts wrong about Matthew Hawley’s first marriage, and in doing so he almost missed the opportunity for a swift winning question. "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Almost")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Can I ask you to think back to that time and explain to me why you didn’t kill your first wife, Amy? Or her new lover Peter? You say they “decimated” your family and it sounds like a desperate time for you. So why not kill "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("them")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Matthew sighed. ‘I’m not a serial killer, Mr Neale. I was an ordinary man whose wife did the dirty, and I had to live with the consequences of not paying her enough attention. She wasn’t the only one at fault. Just because I speak my mind about hating what they did, doesn’t mean I would kill "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("them")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘What made you kill your second wife then, if a painful divorce and betrayal wasn’t enough to drive you to any sort of violent reaction, what did?’ Konrad had floundered. He hadn’t expected Matthew Hawley to be so grounded, rational and "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("implacable")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("The best psychopath I’ve ever met,")]), _vm._v(" he "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("decided")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break ornamental-break-as-image"
  }, [_c('img', {
    staticClass: "inline-ornamental-break",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen-fixed.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("A")]), _vm._v("nnette piped up.")]), _vm._v(" ‘Stop there a second. Where were you going with these opening questions, Kon? You let him sidetrack you. I think we may have to cut that bit of waffle. Scoot through to the question about first meeting Helena.’ The editing suite was silent again as they identified the moment Matthew began the details of his relationship with the woman he would eventually "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("kill")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break ornamental-break-as-image"
  }, [_c('img', {
    staticClass: "inline-ornamental-break",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen-fixed.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("‘")]), _vm._v("W")]), _vm._v("e met through a dating site.")]), _vm._v(" Yes, I know, not romantic or original these days, but I’d avoided any form of relationship for at least two years after my divorce from Amy. I focussed on Josh and we had loads of good times together every Saturday afternoon. We played football, went roller-skating, fishing, that type of boy’s stuff. It was great, and I enjoyed time with Josh, but I’m human after all and hankered for female company that was a bit more meaningful than a quick bang with the barmaid at the Bird in "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Hand")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The interview, with the cameras rolling, became more of a natural conversation as the two men settled into the rhythm of the story. Matthew’s facial features had relaxed as he spoke, remembering with fondness the times together with his only "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("son")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Whose idea was it to try Internet "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("dating")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Gary at work. He’s a bit of a wag on the surface, but he’s a nice bloke who eventually convinced himself that I was heading for eternal solitude and blindness due to nights playing with "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("myself")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Konrad "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("chuckled")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It was Gary who helped with the wording on the application for one of those dating sites for professional singles, and we tinkered about with photos on my phone, trying to make me look macho and confident. Anyway, it worked. I had at least three disastrous dates before I met Helena.’ Matthew rubbed his hands up and down the length of his thighs before being able to continue. Knowing Matthew didn’t react like that when he spoke about Amy and his divorce, Konrad made a mental note to check with the editing team whether that movement was clear to see on film. Matthew gave a short cough before he "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("recommenced")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘She was an absolute stunner. I remember we’d agreed to meet at Gino’s, an Italian restaurant. We’d chatted online about everyday mundane nonsense, you know; books we’d read, sports we enjoyed and food, which is why we settled on Italian for dinner. I’d promised faithfully to arrive early because she said she was worried about turning up on her own and being left in the lurch. So, I made sure I was there sitting at a small table facing the door and I happened to be chatting to the waiter about… I can’t think now, the weather probably, when Helena walked in. My heart "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("sank")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Did it? Why?’ Konrad asked without "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("hesitation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Because there was no way a woman like her was going to find a man like me the least bit attractive. I was fit and healthy all right, but not your toned tanned beefcake, and I wasn’t wealthy or powerful either. I didn’t stand a chance; all the aphrodisiacs were "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("missing")]), _vm._v(".’")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break ornamental-break-as-image"
  }, [_c('img', {
    staticClass: "inline-ornamental-break",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen-fixed.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("A")]), _vm._v("nnette paused")]), _vm._v(" the run-through in the editing room. ‘Do we have that photo of Matthew from when he was first dating Helena? Having sight of that will give the audience a better idea of how much change he went through from the exercise regimes and the surgery, don’t you agree? Let’s make a note of that then. "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Good")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Slow Joe put the digital photo of Matthew Hawley on the computer screen in front of them and Konrad shook his head in disbelief. ‘Christ, he looked like a different man back then. When was this "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("taken")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘The date says twelfth of April "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("2013")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Bloody hell, what a difference between that and the photo of him with Helena at the charity gala a year later. Have we got that one to hand, Joe?’ Konrad asked, intrigued by the contrast between the pictures. After some mouse clicking, Joe managed to get the images side by side on one of the three "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("screens")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Save that please, Joe,’ demanded Annette, who, like Konrad, was staring at the monitor in awe. ‘The nose job is amazing, and look at the difference in his physical shape, he must have spent hours in the gym to get like "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("that")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Nice teeth. They’re definitely expensive. Now look at her, look at Helena, in those pictures. Are you seeing what I’m seeing?’ asked "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Konrad")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The other two men in the room nodded emphatically, but Annette shook her head. ‘No, what about "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("her")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Her tits have got to be two sizes bigger at "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("least")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Are you sure? They can’t be plastic; they look too real. It could be the camera angle, or a better bra. But look at her mouth… see? Fewer lines. Botox probably. Nice lips. She’s a beauty, there’s no doubt about "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("that")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Was a "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("beauty")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yes, you’re right on several counts. We’ll use these contrasting pictures for sure. Nice work. Thanks, Joe. Take a note of the time code at that section, would you. What a lovely sound bite from Matthew. “I didn’t stand a chance; all the aphrodisiacs were missing.”’ Joe looked around as if searching for someone else called Joe, but once it dawned that Annette had paid him a compliment he beamed across at Konrad for "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("confirmation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Following the pause in proceedings, the team returned to the task in hand. Watching and making notes about the interviews with Matthew Hawley in HMP Longlees, Konrad could recall every minute and as he watched the playbacks he relived and analysed each "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("moment")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break ornamental-break-as-image"
  }, [_c('img', {
    staticClass: "inline-ornamental-break",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen-fixed.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("O")]), _vm._v("n the screen")]), _vm._v(" he was seen smiling amiably at Matthew. ‘That was your view but it seems, from the evidence, that Helena must have found something attractive about you, because you had a whirlwind of a courtship leading swiftly to marriage six months later. Most people would say you landed on your feet there, Matthew. Helena Chawston was a wealthy lady, so she wasn’t looking for your money. She ran her own successful business and was a bright, intelligent woman by all accounts. What was it she found in you, do you "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("think")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘A sex "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("toy")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Pardon?’ Konrad sat back in his chair pulling away from Matthew in surprise. "), _c('i', [_vm._v("What the hell? Where did that reply come from? He didn’t say that in "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("court")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘There wasn’t much mention of that specific side of your relationship during your trial, so I find myself wondering why you’ve just made that "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("comment")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You’re right, Helena didn’t need money, but she was attracted to my vulnerability and potential to be the man she wanted in her life. What she needed was my obedience, my loyalty, and undivided attention to make her life complete. I’m not an idiot, but because she took her time to win my affections she made certain, once I had fallen for her, that I couldn’t bear to "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("leave")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Why do you think that "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("was")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Matthew took his time to find the right words. ‘Absolute and overriding dread of rejection was her driving force. Only with hindsight can I see that she continually tested my devotion to alleviate her fears. Although I’m sure any good psychologist could tell you that, if they cared to examine the right evidence. I didn’t understand her motives at the time but I wouldn’t have wanted to leave; she gave me everything. You need to understand, Mr Neale, that Helena was amazing. When I first met her, I thought I’d died and gone to "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("heaven")]), _vm._v(".’")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break ornamental-break-as-image"
  }, [_c('img', {
    staticClass: "inline-ornamental-break",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen-fixed.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("K")]), _vm._v("onrad couldn’t help himself.")]), _vm._v(" As he watched the interview in the editing suite, he thought of his own wife, Delia, and began to drift into a reverie. "), _c('i', [_vm._v("God, she was the sexiest bitch I’d ever had the pleasure of bedding. Those were the days when we first dated…  shagging anywhere and everywhere. Legs up to her armpits and the best tits in town. Nowadays, sex has to be booked into Delia’s diary and it’s a rare treat. “There’s a good boy, thanks for the new earrings, if you really insist on a quick one, do it now before I have to get ready to go to book club. I can spare five minutes. Help yourself and don’t make a "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("mess")]), _vm._v("”.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It took determined mental focus to shake himself back into paying attention to the monitor screens before him, and to Matthew’s "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("words")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a24f5b4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter002.vue
// module id = 84
// module chunks = 0